import Vue from 'vue'
import config from "@/assets/js/config.js"
import dayjs from 'dayjs'
const noImage = require("@/assets/img/no_image100x100.jpg")

var filter = {
  // 阿里相册前缀
  aliAlbumFormat(src, size,aliAlbumHost = null) {
    if (!src) return noImage;
    if(size){
      let match = src.match(/\.\w+$/)
      let ext = match && match.length ? match[0] : ''
      src = src.replace(/(\.\d+x\d+)?\.\w+$/, `.${size}${ext}`)
    }
    return aliAlbumHost ? src: config.aliAlbumHost + src
  },
  // 图片前缀
  imageFormat(src) {
    if (!src) return ""
    return config.imgUrl + src;
  },
  imgFormat(url, size, isNeedHost = true){
    if(size) url = url.replace(/(.\w+$)/g, `.${size}x${size}$1`)
    return (isNeedHost?config.alicdn:'') + url
  },
  // 图片剪裁
  imageThumb(src, w, h) {
    if (!src) return ""
    let width = w || 272;
    let heigh = h || 438;
    return src + `?x-oss-process=image/resize,w_${width},image/crop,x_0,y_0,w_${width},h_${heigh}`;
  },
  // 提取时间戳 example:/Date(1558591720000)/ 
  timeStampFormat(str) {
    if (!str) return ""
    // let reg = /(?<=\/Date\().+(?=\)\/)/;
    let reg = /(\/Date\((\d+)\)\/)/;
    let match = str.match(reg);
    if (match && match.length >= 3) {
      return parseInt(match[2])
    }
    return "";
  },
  // 格式化时间
  dateFormat(timestamp, format = "YYYY-MM-DD HH:mm") {
    if (!timestamp) return "";
    let date = dayjs(timestamp);
    if (date.isValid()) {
      return date.format(format);
    }
    return "";
  },
}

for (var filteritem in filter) {
  Vue.filter(filteritem, filter[filteritem])
}